<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import WorkOrderTablePropertyCell from "../../../../../../_shared/_modules/work-order-table-property-cell"
  import type { WrongRecipientReplacementDraft, WrongRecipientReplacementRow } from "../../contract"

  let {
    row,
    disabled,
  }: InboxWorkflowCellProps<WrongRecipientReplacementRow, WrongRecipientReplacementDraft> = $props()
</script>

<WorkOrderTablePropertyCell addressLabel={row.addressLabel} unitLabel={row.unitLabel} {disabled} />
